module.exports = "<div *ngIf=\"active\" class=\"app-content-loading\">\n  <i class=\"fa fa-spinner fa-spin\" #spinner *ngIf=\"type==0\"></i>\n  <img src=\"http://instantestimator.com/images/timer.gif\" *ngIf=\"type==1\" width=\"200\" style=\"margin-top: 250px;\">\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/utilities/spinner/spinner.component.html
// module id = ../../../../../src/app/utilities/spinner/spinner.component.html
// module chunks = main